import { useEffect } from "react";
import useSignUp from "../../froms/hooks/useSignUp";
import UserForm from "../../froms/signUpUser";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../../../shared/constants";

interface ISignUp {
  onClose?: () => void;
}

const SingUp = ({ onClose }: ISignUp) => {
  const { handleSignUp, handleChange, userForm, token } = useSignUp();

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      if (onClose) {
        onClose();
      } else {
        navigate(`/${PATHS.myPersonal}`);
      }
    }
  }, [token]);

  const isDisabledButton = (function () {
    const dataDisable = { ...userForm };
    delete dataDisable.patronymic;
    delete dataDisable.marketingConsent;
    return Object.values(dataDisable).some(
      (value) => value === null || value === "" || value === false
    );
  })();

  return (
    <UserForm
      data={userForm}
      isDisable={isDisabledButton}
      onChange={handleChange}
      onSendData={handleSignUp}
    />
  );
};

export default SingUp;
